/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input, Inject, PLATFORM_ID, HostListener, OnDestroy, ViewChild, DoCheck } from '@angular/core';
import { SidenavMenuService } from '../sidenav-menu/sidenav-menu.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { environment } from '../../../../environments/environment';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ProductCompareSandbox } from '../../../../core/product-compare/product-compare.sandbox';
import { ProductControlSandbox } from '../../../../core/product-control/product-control.sandbox';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonService } from '../../../../core/common/common.service';
import { ConfigService } from '../../../../core/service/config.service';
import { makeStateKey, Title, TransferState } from '@angular/platform-browser';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ListsService } from '../../../../core/lists/lists.service';
const STATE_KEY_VENDOR_DETAIL = makeStateKey('vendorDetail');

@Component({
  selector: 'app-spurt-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit, OnDestroy, DoCheck {




  public category = { name: 'Select Category' };
  @Input() categories: any;
  public searchValue: any = '';
  public imagePath: any;
  public showSearch = false;
  public language: any;
  public languages: any;
  public setting: any = {};
  // public auto:any
  public languageList = [];
  public imageUrl: any;
  public accountMenuTrigger: any;
  // public imagePath: any;
  public profile: any;
  private subscriptions: Array<Subscription> = [];
  index: any;
  public productSearch: any;
  public vendorShippingMethod: any;
  public totalAmount: any = 0;

  product: any = '';
  productvalue: any;
  slug: any;
  dummyText: any = '';
  public vendors = [];
  public vendorDetail = null;
  public referSetting: any = null;
  private searchSubject = new Subject<string>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,

    public sidenavMenuService: SidenavMenuService,
    public router: Router,
    public formBuilder: FormBuilder,
    public listSandbox: ListsSandbox,
    public commonSandbox: CommonSandbox,
    public compareSandbox: ProductCompareSandbox,
    private translate: TranslateService,
    private titleService: Title,
    public commonService: CommonService,
    public productControl: ProductControlSandbox,
    public configService: ConfigService,
    private state: TransferState,
    private listService: ListsService


  ) { }

  ngOnInit() {

    this.commonSandbox.siteSettings$.subscribe((response) => {
      console.log("  this.setting = response; ", response);
      this.setting = response;

    });
    this.listService.getsettings().toPromise().then(res => {
      console.log(res.data);
      this.referSetting = res.data[0].referSetting;
    }
    )

    this.searchSubject.pipe(debounceTime(200)).subscribe(() => {
      this.searchData();
    });
    this.getLanguageList();
    this.subscribeLanguageList();
    this.imageUrl = this.configService.getImageUrl();
    console.log(" **** this.image url ", this.configService.getImageUrl());
    this.listSandbox.getSettings();
    this.imagePath = this.configService.getImageUrl();
    if (isPlatformBrowser(this.platformId)) {
      this.totalAmount = localStorage.getItem('checkoutCartTotal');
      if (localStorage.getItem('vendorUserDetails')) {
        this.commonSandbox.doGetProfile();
      }
    }

    this.commonSandbox.getProfile$.subscribe(data => {
      if (data) {
        this.profile = data;
      }
    });

    let vendorDetail = this.state.get(STATE_KEY_VENDOR_DETAIL, <any>null);

    if (vendorDetail !== null) {
      console.log("in if vendorShippingMethod");
      console.log(this.vendorShippingMethod);
      this.vendorShippingMethod = vendorDetail.vendorShippingMethod;
      this.commonSandbox.setVendorDetail(vendorDetail);
    } else {
      console.log("in else vendorShippingMethod");
      console.log(this.vendorShippingMethod);
      this.commonService.getVendorDetail().toPromise().then((response: any) => {
        this.commonSandbox.setVendorDetail(response.vendor);
        this.state.set(STATE_KEY_VENDOR_DETAIL, response.vendor);
        this.vendorShippingMethod = response.vendor.vendorShippingMethod;
      });
    }


    this.subscriptions.push(this.commonSandbox.vendorDetail$.subscribe((vendor: any) => {
      if (vendor) {

        this.vendorDetail = vendor;
      }
    }));
  }
  ngDoCheck() {
    if (isPlatformBrowser(this.platformId)) {
      this.totalAmount = localStorage.getItem('shippableAmount');
    }

  }
  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    // this.product = '';
    this.dummyText = '';
    this.showSearch = false;
  }

  setTitle(title) {
    if (title === 'All Products') {
      this.titleService.setTitle('All Products');

    } else if (title === 'Blogs') {
      this.titleService.setTitle(title);

    } else if (title === 'Contacts') {
      this.titleService.setTitle(title);

    } else if (title === 'Home') {
      this.titleService.setTitle(title);

    } else if (title === 'Service') {

    } else if (title === 'Refer a Friend') {
      this.titleService.setTitle(title);
    }
  }



  // seacrh the data in the product list
  public search(data) {
    // this.product = '';
    this.product = data.name;
    this.dummyText = '';
    // this.showSearch = true;
    // this.productvalue=this.productSearch;
    this.slug = data.productSlug;
    this.router.navigate(['/products/productdetails/' + this.slug], { queryParams: { scroll: 1 } });
    this.showSearch = false;
  }

  public goToVendor(data) {
    this.router.navigate(['/vendor-detail/detail/', data.vendorPrefixId], { queryParams: { vendorId: data.vendorId } });
  }


  public searchData() {
    // this.searchValSue = this.product;
    const params: any = {};
    params.keyword = this.product;
    this.dummyText = this.product;
    if (params.keyword) {
      this.listSandbox.getProductsearch(params);
      this.listSandbox.getProductSearch$.subscribe(data => {

      });
      this.listSandbox.getVendorSearch$.subscribe(data => {
        this.vendors = data;
      })
    }

  }

  public changeLanguage(data, indexValue) {
    this.index = indexValue;
    if (isPlatformBrowser(this.platformId)) {
      this.language = localStorage.getItem('language');
      this.language = data;
      if (this.language === 'Hindi') {
        localStorage.setItem('language', 'Hindi');
        this.translate.setDefaultLang('hi');
      } else if (this.language === 'English') {
        localStorage.setItem('language', 'English');
        this.translate.setDefaultLang('en');
      } else if (this.language === 'French') {
        localStorage.setItem('language', 'French');
        this.translate.setDefaultLang('fr');
      }
    }
  }

  subscribeLanguageList() {
    this.subscriptions.push(
      this.listSandbox.settingDetail$.subscribe(datas => {
        if (datas) {
          this.language = datas.storeLanguageName;

          if (isPlatformBrowser(this.platformId)) {
            if (localStorage.getItem('language')) {
              this.languages = localStorage.getItem('language');
              localStorage.setItem('language', this.language);
            } else {
              localStorage.setItem('language', this.language);
              this.languages = localStorage.getItem('language');
            }
          }
          this.languageList.forEach((item, index) => {
            if (item.name === this.languages) {
              this.changeLanguage(this.languages, index);
            }
          });
        }
      })
    );
    this.subscriptions.push(
      this.commonSandbox.getLanguageList$.subscribe(data => {
        if (data && data.length > 0) {
          data.forEach((item, index) => {
            this.languageList.push({
              name: item.name,
              image: item.image,
              imagePath: item.imagePath
            });
            console.log('language list', this.languageList);

            if (item.name === this.language) {
              this.changeLanguage(this.language, index);
            }
          });
        }
      })
    );
  }

  getLanguageList() {
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.count = '';
    this.listSandbox.getSettings();

    this.commonSandbox.getLanguageList(params);

  }

  public changeCategory(event) {
    if (event) {
      this.router.navigate(['/products/', event]);
    }
    if (window.innerWidth < 960) {
      this.stopClickPropagate(event);
    }
  }

  // style purpose
  public stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  // style purpose
  public closeSubMenus() {
    if (window.innerWidth < 960) {
      this.sidenavMenuService.closeAllSubMenus();
    }
    this.product = '';
  }

  signOut() {
    this.commonSandbox.customerLogOut();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('storeUser');
      localStorage.removeItem('storeUserToken');
      localStorage.removeItem('compareId');
      localStorage.clear();
    }
    this.compareSandbox.clearCompare([]);
    this.commonSandbox.doSignout();
    this.productControl.clearCart();
    this.router.navigate(['/auth/sign-in']);
  }
  ngOnDestroy() {
    this.searchSubject.complete();
    this.subscriptions.forEach(each => {
      each.unsubscribe();
    });
  }

  //-----------When Enter To Search Product-----------//
  onEnter() {
    const params: any = {};
    params.keyword = this.product;
    if (this.product) {
      this.router.navigate([
        'products'
      ], {
        queryParams: {
          keyword: this.product
        }
      })
    }
  }
  //-----------End Enter To Search Product-----------//


  searchDataViewAll() {

    if (this.product) {
      this.router.navigate([
        'products'
      ], {
        queryParams: {
          keyword: this.product
        }
      })
    }

  }
}
